module.exports = __webpack_public_path__ + "img/portfolio-details.88b8f25b.webp";